import { useTranslation } from 'react-i18next'

import Text, { TextProps } from 'components/Text'
import { sentenceFormat } from 'utils/string'

import { PopOverItem, TextCase } from './types'

export const resolveTextCase = (
  item?: Pick<PopOverItem, 'value' | 'textCase'>,
  options?: PopOverItem[],
): TextCase | undefined => {
  if (!item) {
    return undefined
  }

  if (item.textCase) {
    return item.textCase
  }

  return options?.find((option) => option.value === item.value)?.textCase
}

type PopOverLabelProps = {
  label: string
  textCase?: TextCase
} & Omit<TextProps, 'children'>

const PopOverLabel = ({ label, textCase, color, ...textProps }: PopOverLabelProps) => {
  const { t } = useTranslation()
  const commonProps = { overflowWrap: 'break-word' as const, lineHeight: '20px', color, ...textProps }

  if (!textCase) {
    return <>{t(label)}</>
  }

  switch (textCase) {
    case 'isCapital': {
      return (
        <Text {...commonProps} textTransform="uppercase">
          {label}
        </Text>
      )
    }
    case 'isSmall':
      return (
        <Text {...commonProps} textTransform="lowercase">
          {label}
        </Text>
      )
    case 'isCamelCase':
      return (
        <Text {...commonProps} textTransform="capitalize">
          {sentenceFormat(t(label))}
        </Text>
      )
    default:
      return <>{t(label)}</>
  }
}

export default PopOverLabel
